import React from 'react';
import Sidebar from './Sidebar';
import { Path } from '../App';
import UserMenu from './user/UserMenu';

interface LayoutProps {
  children: React.ReactNode;
  currentPath: Path;
  onNavigate: (path: Path) => void;
}

export default function Layout({ children, currentPath, onNavigate }: LayoutProps) {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar currentPath={currentPath} onNavigate={onNavigate} />
      <div className="flex-1 flex flex-col">
        <div className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4">
          <div className="flex-1" />
          <UserMenu />
        </div>
        <main className="p-6 flex-1">
          {children}
        </main>
        <footer className="p-4 text-center text-sm text-gray-500">
          <p>Version 1.0.0 • Developed by Quinnel Soft</p>
        </footer>
      </div>
    </div>
  );
}